import User from '@/lib/models/user';
import { login, logged, logout } from '@/lib/services';

export type LoginState = {
  isAuthenticated: boolean;
  loggedUser: User;
  loggedInterval_: number;
}

export default {
  state: <LoginState>{
    isAuthenticated: false,
    loggedUser: null
  },
  getters: {
    loggedUser: state => state.loggedUser,
    userhHasHigherFlexProfileThan: (state: LoginState) => (p: string): boolean => {
      return state.loggedUser.hasHigherFlexProfileThan(p);
    },
    userhHasMinimumFlexProfileThan: (state: LoginState) => (p: string): boolean => {
      return state.loggedUser.hasMinimumFlexProfile(p);
    }
  },
  mutations: {
    authenticate(state: LoginState, data) {
      state.isAuthenticated = true;
      state.loggedUser = data;
    },
    unauthenticate(state: LoginState) {
      state.isAuthenticated = false;
    },
    updateLoggedUserDepts(state: LoginState, depts) {
      state.loggedUser.depts = depts;
    }
  },
  actions: {
    async login({commit, dispatch}, {mail, pass}) {
      try {
        const user = await login({login: mail, pass});
        commit("authenticate", user);
        if ((window as any).rootConfig.EMBEDDED) {
          let loggedInterval = setInterval(async () => {
            const ok = await logged();
            if (!ok) {
              clearInterval(loggedInterval);
              commit("unauthenticate");
            }
          }, 5000);
        }
        dispatch("loadUserCavites");
        return true;
      } catch (e) {
        return false;
      }
    },
    async logout({commit}) {
      const ok = await logout();
      if (ok) commit("unauthenticate");
    }
  }
};
